/** Locale bundles merged from feature JSON files. */
import enCommon from "./en/common.json";
import enChat from "./en/chat.json";
import enVideo from "./en/video.json";
import enEventCheckout from "./en/eventCheckout.json";
import enEventRegistration from "./en/eventRegistration.json";
import arCommon from "./ar/common.json";
import arChat from "./ar/chat.json";
import arVideo from "./ar/video.json";
import arEventCheckout from "./ar/eventCheckout.json";
import arEventRegistration from "./ar/eventRegistration.json";
import frCommon from "./fr/common.json";
import frChat from "./fr/chat.json";
import frVideo from "./fr/video.json";
import frEventCheckout from "./fr/eventCheckout.json";
import frEventRegistration from "./fr/eventRegistration.json";
import esCommon from "./es/common.json";
import esChat from "./es/chat.json";
import esVideo from "./es/video.json";
import esEventCheckout from "./es/eventCheckout.json";
import esEventRegistration from "./es/eventRegistration.json";
import itCommon from "./it/common.json";
import itChat from "./it/chat.json";
import itVideo from "./it/video.json";
import itEventCheckout from "./it/eventCheckout.json";
import itEventRegistration from "./it/eventRegistration.json";
import nlCommon from "./nl/common.json";
import nlChat from "./nl/chat.json";
import nlVideo from "./nl/video.json";
import nlEventCheckout from "./nl/eventCheckout.json";
import nlEventRegistration from "./nl/eventRegistration.json";
import ptCommon from "./pt/common.json";
import ptChat from "./pt/chat.json";
import ptVideo from "./pt/video.json";
import ptEventCheckout from "./pt/eventCheckout.json";
import ptEventRegistration from "./pt/eventRegistration.json";
import zhCommon from "./zh/common.json";
import zhChat from "./zh/chat.json";
import zhVideo from "./zh/video.json";
import zhEventCheckout from "./zh/eventCheckout.json";
import zhEventRegistration from "./zh/eventRegistration.json";

export const i18nResources = {
  en: { translation: { ...enCommon, ...enChat, ...enVideo, ...enEventCheckout, ...enEventRegistration } },
  ar: { translation: { ...arCommon, ...arChat, ...arVideo, ...arEventCheckout, ...arEventRegistration } },
  fr: { translation: { ...frCommon, ...frChat, ...frVideo, ...frEventCheckout, ...frEventRegistration } },
  es: { translation: { ...esCommon, ...esChat, ...esVideo, ...esEventCheckout, ...esEventRegistration } },
  it: { translation: { ...itCommon, ...itChat, ...itVideo, ...itEventCheckout, ...itEventRegistration } },
  nl: { translation: { ...nlCommon, ...nlChat, ...nlVideo, ...nlEventCheckout, ...nlEventRegistration } },
  pt: { translation: { ...ptCommon, ...ptChat, ...ptVideo, ...ptEventCheckout, ...ptEventRegistration } },
  zh: { translation: { ...zhCommon, ...zhChat, ...zhVideo, ...zhEventCheckout, ...zhEventRegistration } },
};
